import { resolveAll } from '../helpers/LinkMapper';
import AuthenticatedAPIClient from '../lib/AuthenticatedAPIClient';
import STicket from '../records/sticket/STicket';
import STicketCoupon from '../records/sticket/STicketCoupon';
import { APIPager } from '../helpers/Pager';

const STicketService = {
    async loadSTickets(userId) {
        const url = `/stickets/${userId}/tickets`;

        const result = await AuthenticatedAPIClient.get(url);

        return resolveAll(result)
            .as(STicket)
            .sort((a, b) => (a.purchaseDateTime.isBefore(b.purchaseDateTime) ? 1 : -1)); // sort in descending order
    },

    async getAllSurfacedCoupons(userId, search = '') {
        const url = `/stickets/${userId}/coupons/surfaced${search}`;

        const { result, pagination } = await AuthenticatedAPIClient.get(url);

        return { coupons: resolveAll(result).as(STicketCoupon), pagination: new APIPager(pagination)};
    },

    async loadSTicketPhotoRequests(user) {
        const url = `/stickets/image/${user.id}/changes?status=pending`;
        return AuthenticatedAPIClient.get(url);
    }
};

export default STicketService;



// WEBPACK FOOTER //
// ./src/services/STicketService.js